import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csforloop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
  
return(
      <div>
      <Sides/>
 
      <Helmet>
 
 <title>Learn Free PHP For Loop Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php for loop tutorial for beginners.for loop in Php is The body of the loop must be executed until the given condition is false. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php for loop increment by 10,php for loop programs,php for loop syntax,tutorial for begineers,php for loop array length,php for loop example,php for loop count,,php for loop break,Php for loop,php for loop array,end for loop Php,Php exit for loop,php for loop continue,Php foreach for loop" />
 <link rel="canonical" href="https://www.codeexampler.com/php-for-loop" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php for Loop</h1>
    <div className="first">
        <a href="/php-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">for loop in Php
</h2>
<p className="mt-4 para">1, The body of the loop must be Executes until the given condition is false<br/>
2, In the Php for loop semicolon, must be used <br/>
3, This Php for loop is using to repeat a particular piece of code for a fixed no of times<br/>

</p>


<h2 className='headings'>Php for loop syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}  {"\n"}
            <span className="qwerty-4">For </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-1"> initialization; condition; iteration </span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-10">Statement sequence </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}  {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Php for loop example:</h2>


<h2 className='headings'>Q-Write a Program to print a number from 1 to 10 in PHP for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-7">?</span>
            <span className="qwerty-5">php</span>
            {"\n"}
            <span className="qwerty-7">for</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">$</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">$</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">$</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">Loop</span>
            <span className="qwerty-2"> Start</span>
            <span className="qwerty-10"> : </span>
            <span className="qwerty-3">".</span>
            <span className="qwerty-10">$</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-3">."</span>
            <span className="qwerty-3">\</span>
            <span className="qwerty-3">n</span>
           
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-7">?</span>
            <span className="qwerty-3">&#62;</span>
            {"\n"}  {"\n"}
          </code>
        </pre>
      </div>
      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}   
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 1 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 2 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 3 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 4 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 5 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 6 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 7 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 8 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 9 </span>
              {"\n"}
              <span className="qwerty-3">Loop</span>
              <span className="qwerty-2"> Start</span>
              <span className="qwerty-6"> 10 </span>
              {"\n"}  {"\n"}
            </code></pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to print a name when the program is complete in Php for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">?</span>
            <span className="qwerty-3">php</span>
            {"\n"}
            <span className="qwerty-5">for </span>
            <span className="qwerty-3"> (</span>
              <span className="qwerty-4">$</span>
              <span className="qwerty-1">i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-10"> 1</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-4">$</span>
              <span className="qwerty-1">i</span>
              <span className="qwerty-4">&#60;</span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-10">10</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-4">$</span>
              <span className="qwerty-1">i</span>
              <span className="qwerty-1">++</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">$</span>
              <span className="qwerty-1">i</span>
            <span className="qwerty-10">."</span>
            <span className="qwerty-4">\</span>
            <span className="qwerty-10">n</span>
            
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-6">CodeExampler</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-5">?</span>
            <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-10">1 </span>
            {"\n"} 
              <span className="qwerty-10">2 </span>
              {"\n"} 
              <span className="qwerty-10">3 </span>
              {"\n"} 
              <span className="qwerty-10">4 </span>
              {"\n"} 
              <span className="qwerty-10">5 </span>
              {"\n"} 
              <span className="qwerty-10">6 </span>
              {"\n"} 
              <span className="qwerty-10">7 </span>
              {"\n"} 
              <span className="qwerty-10">8 </span>
              {"\n"} 
              <span className="qwerty-10">9 </span>
              {"\n"} 
              <span className="qwerty-10">10 </span>
              {"\n"}
              <span className="qwerty-6">CodeExampler</span>
              {"\n"}
             </code>{"\n"}</pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to print a name again and loop increment by 10 with Ram Ram Word in Php for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}   
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">?</span>
            <span className="qwerty-3">php</span>
            {"\n"}
            <span className="qwerty-4">for</span>
            <span className="qwerty-4"> (</span>
              <span className="qwerty-3">$</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-1"> 1</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-3">$</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-4">&#60;</span>
              <span className="qwerty-3">=</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-3">$</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">++</span>
            <span className="qwerty-4">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">echo </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">Ram Ram</span>
            <span className="qwerty-4"> \</span>
            <span className="qwerty-10">n</span>
        
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">?</span>
            <span className="qwerty-3">&#62;</span>
            {"\n"}        {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-1">1 </span>
           
              <span className="qwerty-7">Ram Ram </span> {"\n"}
            
              <span className="qwerty-1">2 </span>

              <span className="qwerty-7">Ram Ram </span>  {"\n"} 
           
              <span className="qwerty-1">3 </span>
                 <span className="qwerty-7">Ram Ram </span>              {"\n"}
     
              <span className="qwerty-1">4 </span>
          
              <span className="qwerty-7">Ram Ram </span>              {"\n"}
           
              <span className="qwerty-1">5 </span>
            
              <span className="qwerty-7">Ram Ram </span>              {"\n"}
          
              <span className="qwerty-1">6 </span>
              
              <span className="qwerty-7">Ram Ram </span>              {"\n"}
          
              <span className="qwerty-1">7 </span>
           
              <span className="qwerty-7">Ram Ram </span>              {"\n"}
          
              <span className="qwerty-1">8 </span>
          
              <span className="qwerty-7">Ram Ram </span>              {"\n"}
      
              <span className="qwerty-1">9 </span>
   
              <span className="qwerty-7">Ram Ram </span>              {"\n"}
    
              <span className="qwerty-1">10</span>
  
              <span className="qwerty-7">Ram Ram </span>              {"\n"}

              </code>{"\n"}</pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to print a name again and loop increment by 10 with Hello Ram Word in Php for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-3">?</span>
            <span className="qwerty-2">php</span>
            {"\n"}
            <span className="qwerty-5">for</span>
            <span className="qwerty-4"> (</span>
              <span className="qwerty-1">$</span>
              <span className="qwerty-7">i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-6"> 1</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-1">$</span>
              <span className="qwerty-7">i</span>
              <span className="qwerty-4"> &#60;</span>
              <span className="qwerty-3">=</span>
              <span className="qwerty-6">10</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-1">$</span>
              <span className="qwerty-7">i</span>
              <span className="qwerty-3">++</span>
            <span className="qwerty-4">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">Hello </span>
            <span className="qwerty-3">Ram</span>
            <span className="qwerty-10">".</span>
            <span className="qwerty-1">$</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-4">." \</span>
            <span className="qwerty-10">n</span>
         
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-3">?</span>
            <span className="qwerty-4">&#62; </span>
            {"\n"}  {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">1 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">2 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">3 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">4 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">5 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">6 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">7 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">8 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">9 </span>
              {"\n"} 
              <span className="qwerty-5">Hello </span>
              <span className="qwerty-3">Ram </span>
              <span className="qwerty-1">10 </span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to Fibonacci series in Php for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}  
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">?</span>
            <span className="qwerty-3">php</span>
            {"\n"}
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-6">0</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">for</span>
            <span className="qwerty-4"> (</span>
              <span className="qwerty-5">$</span>
              <span className="qwerty-1">i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-6"> 1</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-5">$</span>
              <span className="qwerty-1">i</span>
              <span className="qwerty-4">&#60;</span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-6">10</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-5">$</span>
              <span className="qwerty-1">i</span>
              <span className="qwerty-3">++</span>
            <span className="qwerty-4">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-10">echo </span>
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-3">."</span>
           
            <span className="qwerty-10">\</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-5">$</span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">?</span>
            <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-6">1 </span>
              {"\n"} 
              <span className="qwerty-6">2 </span>
              {"\n"} 
              <span className="qwerty-6">3 </span>
              {"\n"} 
              <span className="qwerty-6">5 </span>
              {"\n"} 
              <span className="qwerty-6">8 </span>
              {"\n"} 
              <span className="qwerty-6">13 </span>
              {"\n"} 
              <span className="qwerty-6">21 </span>
              {"\n"} 
              <span className="qwerty-6">34 </span>
              {"\n"} 
              <span className="qwerty-6">55 </span>
              {"\n"} 
              <span className="qwerty-6">89 </span>
              {"\n"}
            </code>{"\n"}</pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/php-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csforloop;